import { useMediaQuery } from "./useMediaQuery";

export const usePrefersReducedMotion = (): boolean => useMediaQuery("(prefers-reduced-motion: reduce)");
